var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bluefire-wap-wrap"},[_c('wap-header',{attrs:{"header-text":"昆仑数据信息平台","header-visible":true,"back-visible":true}}),_c('div',{staticClass:"pdfview-wrap"},[_c('pdf-view',{attrs:{"src":_vm.pdfUrl}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }